import { render, staticRenderFns } from "./ManualMessageSolution.vue?vue&type=template&id=5b30f9a0&"
import script from "./ManualMessageSolution.vue?vue&type=script&lang=js&"
export * from "./ManualMessageSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b30f9a0')) {
      api.createRecord('5b30f9a0', component.options)
    } else {
      api.reload('5b30f9a0', component.options)
    }
    module.hot.accept("./ManualMessageSolution.vue?vue&type=template&id=5b30f9a0&", function () {
      api.rerender('5b30f9a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ManualMessageSolution.vue"
export default component.exports